module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card demo-card-header-pic"
    }, [_c('div', {
      staticClass: "card-header color-white no-border"
    }, [_vm._v("订单" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-content-inner"
    }, [_c('p', {
      staticClass: "color-gray"
    }, [_vm._v("@2015/01/15")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-80",
      staticStyle: {
        "height": "auto",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_vm._v(_vm._s(product.ProductName))])])])]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v("再次购买")]), _vm._v(" "), _c('router-link', {
      staticClass: "item-link",
      attrs: {
        "to": {
          name: 'orderDetail'
        }
      }
    }, [_vm._v("订单详情")])], 1)])
  })], 2), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("订单详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons-tab"
  }, [_c('a', {
    staticClass: "tab-link active button",
    attrs: {
      "href": "#tab1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab2"
    }
  }, [_vm._v("待支付")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab3"
    }
  }, [_vm._v("待发货")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("This is tab 1 content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-20"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/gene.jpg",
      "width": "100%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("This is tab 2 content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("This is tab 3 content")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7d6af54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyOrders/Orders.vue
// module id = 1741
// module chunks = 8